import IconAlarmPause from '@iconify/icons-material-symbols/alarm-outline';
import IconCampaign from '@iconify/icons-material-symbols/campaign-outline';
import IconConfirmation from '@iconify/icons-material-symbols/confirmation-number-outline';
import { useTranslation } from 'react-i18next';
import { TicketView, useGetTicketTrends } from '#pie/internal/api/pie-bff';
import { KpiCard } from '../kpi-card/KpiCard';
import { Stack } from '../stack/Stack';

export const KpiCards = () => {
  const { t } = useTranslation();
  const { data: kpiData, isPending } = useGetTicketTrends();

  return (
    <Stack className="grid grid-cols-3 gap-6">
      <KpiCard
        title={t('kpi_card.open.title')}
        icon={IconConfirmation}
        iconColor="text-content-info"
        bgColor="bg-surface-info"
        ticketView={TicketView.OpenOrHandled}
        data={kpiData?.nrOfOpenTickets}
        isLoading={isPending}
      />
      <KpiCard
        title={t('kpi_card.action.title')}
        icon={IconCampaign}
        iconColor="text-content-warning"
        bgColor="bg-surface-warning"
        ticketView={TicketView.ActionNeeded}
        data={kpiData?.nrOfActionNeededTickets}
        isLoading={isPending}
      />
      <KpiCard
        title={t('kpi_card.no_activity.title')}
        icon={IconAlarmPause}
        iconColor="text-content-help"
        bgColor="bg-surface-help"
        ticketView={TicketView.Stale}
        data={kpiData?.nrOfStaleTickets}
        isLoading={isPending}
      />
    </Stack>
  );
};
